import BaseApi from "./BaseApi"

// 获取初始化数据
export function getInitData(req){  
  return BaseApi.post("/main/getInitData", req);
}

// 获取循环
export function getLoopBySectCode(req){  
  return BaseApi.get("/api/public/v1/compute/getLoopBySectCode", req);
}